export enum ETipoOperacao {
    Visualizar = 1,
    Incluir = 2,
    Alterar = 3,
    Excluir = 4,
    Imprimir = 5,
    Saida
}
